<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <h2>My Commissions</h2>

          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive" *ngIf="showData">
              <table id="all-sharing-formula" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th >S/N</th>
                  <th>Description</th>
                  <th>Transaction Type</th>
                  <th>Action</th>

                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th >S/N</th>
                  <th>Description</th>
                  <th>Transaction Type</th>
                  <th>Action</th>

                </tr>
                </tfoot>
                <tbody>

                <tr *ngFor="let share of sharingFormulas;let i = index;">

                  <td [id]="'td-' + i" > {{ i + 1}}</td>

                  <td>{{ share?.description }}</td>
                  <td>{{ share?.transaction_type }}</td>
                  <td>
                    <div>
                        <span role="button" data-balloon="View Details" data-balloon-pos="up" >
                                          <i class="fa fa-eye text-primary"></i>
                                        </span>
                    </div>
                  </td>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

    </div>



  </div>
</div>



